import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  Grid,
  Box,
  IconButton,
} from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';

interface OtherActionsModalProps {
  open: boolean;
  onClose: () => void;
  refreshing: boolean;
  loading: boolean;
  n11IntegrationActive: boolean;
  onNavigateToImageLibrary: () => void;
  onOpenTableSettings: () => void;
  onOpenShipmentTemplates: () => void;
  onOpenN11Log: () => void;
  onOpenN11Upload: () => void;
  onRefreshInventory: () => void;
}

export const OtherActionsModal: React.FC<OtherActionsModalProps> = ({
  open,
  onClose,
  refreshing,
  loading,
  n11IntegrationActive,
  onNavigateToImageLibrary,
  onOpenTableSettings,
  onOpenShipmentTemplates,
  onOpenN11Log,
  onOpenN11Upload,
  onRefreshInventory,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          mx: { xs: 2, sm: 3 }
        }
      }}
    >
      <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 2, px: 3 }}>
        <Box display="flex" alignItems="center">
          <InventoryIcon sx={{ mr: 1, fontSize: 28 }} />
          <Typography variant="h6" fontWeight="bold">
            Diğer İşlemler
          </Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Grid container spacing={2}>
          {/* Resim Kütüphanesi */}
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              size="large"
              startIcon={<PhotoLibraryIcon />}
              onClick={() => {
                onNavigateToImageLibrary();
                onClose();
              }}
            >
              Resim Kütüphanesi
            </Button>
          </Grid>
          
          {/* Tabloyu Özelleştir */}
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              size="large"
              startIcon={<ViewColumnIcon />}
              onClick={() => {
                onOpenTableSettings();
                onClose();
              }}
            >
              Tabloyu Özelleştir
            </Button>
          </Grid>
          
          {/* Kargo Şablonları */}
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              size="large"
              startIcon={<LocalShippingIcon />}
              onClick={() => {
                onOpenShipmentTemplates();
                onClose();
              }}
            >
              Kargo Şablonları
            </Button>
          </Grid>
          
          {/* Log */}
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="info"
              size="large"
              startIcon={<AssessmentIcon />}
              onClick={() => {
                onOpenN11Log();
                onClose();
              }}
            >
              Pazaryeri İşlem Logları
            </Button>
          </Grid>
          
          {/* Hepsiburada Katalog */}
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              size="large"
              startIcon={<CloudUploadIcon />}
              disabled={true}
              sx={{
                opacity: 0.6,
                '&.Mui-disabled': {
                  color: 'text.secondary',
                  borderColor: 'rgba(0, 0, 0, 0.12)'
                }
              }}
            >
              Hepsiburada Katalog (Yakında)
            </Button>
          </Grid>
          
          {/* Trendyol Katalog */}
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              size="large"
              startIcon={<CloudUploadIcon />}
              disabled={true}
              sx={{
                opacity: 0.6,
                '&.Mui-disabled': {
                  color: 'text.secondary',
                  borderColor: 'rgba(0, 0, 0, 0.12)'
                }
              }}
            >
              Trendyol Katalog (Yakında)
            </Button>
          </Grid>
          
          {/* N11 Katalog */}
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              size="large"
              startIcon={<CloudUploadIcon />}
              onClick={() => {
                onOpenN11Upload();
                onClose();
              }}
              disabled={!n11IntegrationActive}
              sx={{
                opacity: n11IntegrationActive ? 1 : 0.6,
                '&.Mui-disabled': {
                  color: 'text.secondary',
                  borderColor: 'rgba(0, 0, 0, 0.12)'
                }
              }}
            >
              N11 Katalog {n11IntegrationActive ? '✅' : '❌'}
            </Button>
          </Grid>

          {/* Yenile */}
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              size="large"
              startIcon={<RefreshIcon />}
              onClick={() => {
                onRefreshInventory();
                onClose();
              }}
              disabled={refreshing || loading}
            >
              {refreshing ? 'Yenileniyor...' : 'Stok Listesini Yenile'}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

